import i18n from "@/store/i18n"

export const UNIT_TYPES = {
  MAX_REPS: "max_reps",
  SEC_SIDE: "sec_side",
  REP_SIDE: "rep_side",
  CLUSTER_SET: "cluster_set",
  DROP_SET: "drop_set",
  BREATHE_SIDE: "breathe_side"
}

const INTENSITY_TYPES = {
  TEMPO: "tempo",
  BODYWEIGHT: "%_body"
}

const pluralize = text => (text.endsWith("s") ? text : `${text}s`)
const pluralizeWithUnit = (units, text) =>
  units === 1 ? text : pluralize(text)

export const formatItemUnits = (unitType, units) =>
  unitType === UNIT_TYPES.MAX_REPS ? "" : `${units}&nbsp;`

export const formatUnitType = (unitType, units) => {
  const intUnits = parseWorkoutUnits(units)
  if (unitType === UNIT_TYPES.SEC_SIDE) {
    return i18n.t("lib.workoutUtils.secSide")
  } else if (unitType === UNIT_TYPES.REP_SIDE) {
    return i18n.t("lib.workoutUtils.repSide")
  } else if (unitType === UNIT_TYPES.MAX_REPS) {
    return i18n.t("lib.workoutUtils.maxReps")
  } else if (unitType === UNIT_TYPES.BREATHE_SIDE) {
    return i18n.t("lib.workoutUtils.breatheSide")
  } else if (unitType === UNIT_TYPES.CLUSTER_SET) {
    return pluralizeWithUnit(intUnits, i18n.t("lib.workoutUtils.clusterSet"))
  } else if (unitType === UNIT_TYPES.DROP_SET) {
    return pluralizeWithUnit(intUnits, i18n.t("lib.workoutUtils.dropSet"))
  } else {
    let keyStr = unitType
      .split("_")
      .map(unit => (intUnits > 1 ? pluralize(unit) : unit))
      .join("/")
    return i18n.t(`lib.workoutUtils.${keyStr}`)
  }
}

export const formatIntensityUnitType = intensityType => {
  if (intensityType === INTENSITY_TYPES.TEMPO) {
    return "Tempo"
  } else if (intensityType === INTENSITY_TYPES.BODYWEIGHT) {
    return "% Bodyweight"
  } else {
    return intensityType
      .split("_")
      .map(u => u.toUpperCase())
      .join(" ")
  }
}

export const getGroupTime = group => {
  let period = null
  let interval = null
  let countIn = true

  if (group.is_rest) {
    period = group.rest_period
    interval = group.rest_interval
    countIn = false
  } else if (group.has_timer || group.is_amrap) {
    period = group.timer_period
    interval = group.timer_interval
  }

  if (period && interval) {
    return { period, interval, countIn }
  } else {
    return null
  }
}

export const getGroupItemTime = item => {
  let period = null
  let interval = null
  let countIn = true

  if (item.is_rest) {
    period = item.rest_period
    interval = item.rest_interval
    countIn = false
  } else if (
    parseWorkoutUnits(item.units) &&
    ["sec", "min", "hour", UNIT_TYPES.SEC_SIDE].includes(item.unit_type)
  ) {
    period = parseWorkoutUnits(item.units)
    interval = item.unit_type === UNIT_TYPES.SEC_SIDE ? "sec" : item.unit_type
    countIn = true
  }

  if (period && interval) {
    return { period, interval, countIn }
  } else {
    return null
  }
}

export const parseWorkoutUnits = units => {
  if (!units) {
    return null
  }

  if (typeof units === "string") {
    const range = units.split("-").map(t => parseInt(t))
    return range[range.length - 1]
  } else {
    return units
  }
}
